import request from "@/util/http";

export function index(query) {
	return request({
		url: '/goods/shop/goods_category',
		method: 'get',
		params: query,
	})
}

